import { compose, createStore, applyMiddleware, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk'; // use for asynchronous actions
import { routerReducer } from 'react-router-redux';

import loggerMiddleware from 'lib/middlewares/loggerMiddleware'; // logging... disable for production
import reducers from '../redux/reducers';
import { initalStates } from '../redux/reducers';

////////////////// EDIT //////////////////

export default props => {
  // This is how we get initial props Rails into redux.
  const { initial_params } = props;
  const { $$initialState } = initalStates;
  // Redux expects to initialize the store using an Object, not an Immutable.Map
  var state = $$initialState.merge({
    initial_params,
  });

  ////////////////// PERMANENT //////////////////
  const initialState = {
    $$appStore: state,
  };

  const reducer = combineReducers({
    ...reducers,
    routing: routerReducer,
  });

  const composedStore = compose(
    applyMiddleware(thunkMiddleware, loggerMiddleware)
  );
  const storeCreator = composedStore(createStore);
  return storeCreator(reducer, initialState);
};
